import React, { useEffect, useState } from 'react';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import { useTranslation } from 'react-i18next';
import reportIssuesService from '@rd-web-markets/shared/dist/services/report_issues.service';
import ReportIssuesTable from '@components/admin/report_issues/ReportIssueTable';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';

export default function MyReportIssuesPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [users] = UserService.useFetchUsersForSelect('', { assignable_to_issues: true });

  const usersById = users.reduce((acc, u) => { acc[u.value] = u.label; return acc; }, {});

  useEffect(() => {
    UserService.getCurrent().then((res) => setCurrentUserId(res?.user?.id));
  }, []);

  const { reports, fetchReports } = reportIssuesService.useCrud(setLoading);

  useEffect(() => {
    if (currentUserId) fetchReports({ assignee_user_id: currentUserId, page: 1 });
  }, [currentUserId, fetchReports]);

  return (
    <>
      <BreadcrumbsPortal>
        <Breadcrumb>
          <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>{t('my_issues')}</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbsPortal>

      <Row className="justify-content-center mx-0 mt-4">
        <Col md={10}>
          <h4 className="mb-3">{t('my_issues')}</h4>
          <ReportIssuesTable reports={reports} usersById={usersById} loading={loading} />
        </Col>
      </Row>
    </>
  );
}
